<script lang="ts">
  import Drawer from '../../components/ui/Drawer.svelte';
  import type { DrawerRequest } from '../context.js';

  interface Props {
    request: DrawerRequest | null;
    onclose: () => void;
  }

  let { request, onclose }: Props = $props();

  let open = $derived(!!request);
</script>

<Drawer open={open} title={request?.title ?? ''} onclose={onclose}>
  {#if request?.content}
    <p class="text-sm text-tx42-text-muted">{request.content}</p>
  {/if}
</Drawer>
